import _ from 'lodash';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { GetRecommendTranslateKeywordService } from '../get-recommend-translate-keyword-service';
import { RecommendTranslateKeywordApi } from '@/infrastructure/api-functions/core-drafting-api/recommend-translate-keyword-api';
import { SuggestionModel } from '../../models/suggestion-model';

@injectable()
export class GetRecommendTranslateKeywordServiceImpl implements GetRecommendTranslateKeywordService {
    constructor(
        @inject(SuggestionModel)
        private readonly _suggestionModel: SuggestionModel,
        @inject(RecommendTranslateKeywordApi)
        private readonly _recommendTranslateKeywordApi: RecommendTranslateKeywordApi,
    ) {}

    async getRecommendTranslateKeyword(taskId: string) {
        this._suggestionModel.update(state => {
            state.isLoading = true;
            return state;
        });
        const data = await this._getRecommendTranslateKeywordFromServer(taskId);
        const suggestions = _.map(data, item => ({
            original: item.original,
            translation: item.translation,
            percentage: item.percentage,
            aiRecommend: item.airecommend,
        }));
        this._suggestionModel.update(state => {
            state.isLoading = false;
            state.suggestions = suggestions;
            return state;
        });
        return suggestions;
    }

    private _getRecommendTranslateKeywordFromServer(taskId: string) {
        return this._recommendTranslateKeywordApi.getRecommendTranslateKeyword({
            taskId,
        });
    }
}
